import { Tooltip } from "@mui/material";
import React, { JSX } from "react";
import { Dropdown } from "react-bootstrap";

type DropDownData = {
  data:
    | Array<string>
    | Array<number>
    | Array<{
        Header: string;
        Value: string | number;
      }>;
  onclick: (item: string | number) => void;
  title: string;
  css?: React.CSSProperties;
  disabled?: boolean;
};

export function DropDown({
  data,
  onclick,
  title,
  css,
  disabled,
}: Readonly<DropDownData>) {
  if (data.length === 0) return <></>;

  return (
    <Dropdown
      style={{
        border: "0.5px solid #01393F",
        borderRadius: "5px",
        minWidth: "100px",
      }}
      className="d-inline"
    >
      <Dropdown.Toggle
        variant=""
        style={{
          fontSize: 12,
          fontWeight: "700",
          letterSpacing: "2px",
          paddingBottom: "0",
          height: "100%",
          float: "right",
          ...css,
        }}
        id="dropdown-autoclose-inside"
      >
        {title}&nbsp;
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          fontSize: 12,
          width: "fit-content",
        }}
      >
        {data.map(
          (
            item:
              | string
              | number
              | {
                  Header: string;
                  Value: string | number;
                }
          ) => {
            if (typeof item === "object")
              return tooltipItem(
                <Dropdown.Item
                  disabled={disabled}
                  key={item.Header}
                  onClick={() => onclick(item.Value)}
                >
                  {item.Header}
                </Dropdown.Item>,
                disabled,
                item.Header
              );
            return tooltipItem(
              <Dropdown.Item
                disabled={disabled}
                key={item}
                onClick={() => onclick(item)}
              >
                {item}
              </Dropdown.Item>,
              disabled,
              item.toString()
            );
          }
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
}

function tooltipItem(
  children: JSX.Element,
  disabled: boolean,
  key: string
): JSX.Element {
  if (disabled)
    return (
      <Tooltip
        key={key}
        title={"Ärendet måste öppnas för att tilldela tekinker"}
        placement="top"
        arrow
        enterDelay={250}
      >
        <span>{children}</span>
      </Tooltip>
    );
  return children;
}
